import React from 'react'
import Header from '../comman/Header'
import Footer from '../comman/Footer'
import Timer from '../comman/Timer'
import CountUp from 'react-countup';
import Partners from './Home/Partners';
import Flags from './Home/Flags';
import Accommodation from './Home/Accommodation';
import Woware from './Home/Woware';

export const Home = () => {
  return (
    <>
 
<Header/>
  <section className="new_section  position-relative">
    <div
      id="carouselExampleFade"
      className="carousel slide carousel-fade"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img src="img/banner1.jpg" className="d-block w-100" alt="banner" />
        </div>
        <div className="carousel-item">
          <img src="img/banner2.jpg" className="d-block w-100" alt="banner" />
        </div>
      </div>
    </div>
    <div className="banner_content text-center">
      <div className="container">
        <h1>
          World Blockchain
          <br /> <span className="color1">Investment</span> Expo Korea 2025{" "}
        </h1>
        <h4 className="ttu">The world's largest blockchain technology <br/>investment summit
        </h4>
        <Timer/>
       
        <div className="top-btns mt-3 mt-md-4">
          <a className="btn_box " href="#" tabIndex={0}>
            Become sponsor
          </a>
          <a className="btn_box   " href="#" tabIndex={0}>
            Buy Tickets
          </a>
        </div>
      </div>
    </div>
  </section>
  <div className="container">
    <div className="clockdiv2" id="section_counter">
      <div className="row">
        <div className="col-md-3 col-6">
          <div
            className="counter-item"
            style={{
              animation: "0.3s ease 0.5s 1 normal forwards running slide-up"
            }}
          >
            <div className="count">
              <CountUp end={50000}  duration={2.75} /> <span>+</span>
            </div>
            <span>Visitors</span>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div
            className="counter-item"
            style={{
              animation: "0.3s ease 0.75s 1 normal forwards running slide-up"
            }}
          >
            <div className="count" >
               <CountUp end={200}  duration={2.75} /> <span>+</span>
            </div>
            <span>Companies</span>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div
            className="counter-item"
            style={{
              animation: "0.3s ease 1s 1 normal forwards running slide-up"
            }}
          >
            <div className="count"  >
            <CountUp end={60}  duration={2.75} /> <span>+</span>
            </div>
            <span>Speakers</span>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div
            className="counter-item"
            style={{
              animation: "0.3s ease 1.25s 1 normal forwards running slide-up"
            }}
          >
            <div className="count" >
            <CountUp end={50}  duration={2.75} /> <span>+</span>
            </div>
            <span>Countries</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Woware/>

  <section className="hero position-relative p70">
    <div className="container">
      <h2 className="hadding ttu text-center mb-md-5">
        Buy <span className="color1">Tickets </span>{" "}
      </h2>
      <div className="row justify-content-center">
        <div
          id="green_pricing_block_2"
          className="pricing-block col-lg-4 col-md-6 col-sm-12 mb-md-0 mb-3">
          <div id="green_pricing_box_2" className="inner-box inner-box1">
            <div className="price-box">
              <h4 className="title">STANDARD</h4>
              <div className="price">
                <div className="d-inline-flex align-items-center">
                  <div className="prices-1 "> 
                    <p>$290 </p>
                  </div>
                  <div className="prices-5"> 
                    <p>$145 </p>
                  </div>
                </div>
                <h6>PRICE </h6>
              </div>
            </div>
            <div className="features-section">
              <ul className="features">
                <li className="true">Exhibition Access</li>
                <li className="true">2 Days Conference Access</li>
                <li className="true">Access to Mobile App</li>
                <li className="false">Differentiated Badge</li>
                <li className="false">Networking Opportunities</li>
              </ul>
            </div>
            <div className="btn-box">
              <a id="button_2" href="#" className="btn">
                Buy Ticket
              </a>
            </div>
          </div>
        </div>
        <div
          id="green_pricing_block_7"
          className="pricing-block col-lg-4 col-md-6 col-sm-12 mb-md-0 mb-3">
          <div id="green_pricing_box_7" className="inner-box inner-box2">
            <div className="price-box">
              <h4 className="title">DELEGATE</h4>
              <div className="price">
                <div className="d-inline-flex align-items-center">
                  <div className="prices-1 ">
                    {" "}
                    <p>$1200 </p>
                  </div>
                  <div className="prices-5">
                    {" "}
                    <p>$600 </p>
                  </div>
                </div>
                <h6>PRICE </h6>
              </div>
            </div>
            <div className="features-section">
              <ul className="features">
                <li className="true">Exhibition Access</li>
                <li className="true">2 Days Conference Access</li>
                <li className="true">Access to Mobile App</li>
                <li className="true">Differentiated Badge</li>
                <li className="true">Networking Opportunities</li>
              </ul>
            </div>
            <div className="btn-box">
              <a id="button_7" href="#" className="btn">
                Buy Ticket
              </a>
            </div>
          </div>
        </div>
        <div
          id="green_pricing_block_3"
          className="pricing-block col-lg-4 col-md-6 col-sm-12 mb-md-0 mb-3">
          <div id="green_pricing_box_3" className="inner-box inner-box3">
            <div className="price-box">
              <h4 className="title">VIP PASS</h4>
              <div className="price">
                <div className="d-inline-flex align-items-center">
                  <div className="prices-1 "> 
                    <p>$1900 </p>
                  </div>
                  <div className="prices-5"> 
                    <p>$950 </p>
                  </div>
                </div>
                <h6>PRICE </h6>
              </div>
            </div>
            <div className="features-section">
              <ul className="features">
                <li className="true">2 Days Conference Access</li>
                <li className="true">Access to Mobile App</li>
                <li className="true">Differentiated Badge</li>
                <li className="true">Networking Opportunities</li>
                <li className="true">VIP Registration Desk</li>
              </ul>
            </div>
            <div className="btn-box">
              <a id="button_3" href="#" className="btn">
                Buy Ticket
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="speaker-section-4 position-relative p70">
    <div className="container position-relative zindex">
      <h2 className="hadding ttu text-center mb-4 mb-md-5"> Exhibitor </h2>
      <div className="row justify-content-center">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="img_box">
            <div className="uimg_box">
              <img src="img/t1.png" alt="img" className="user_img" />
            </div>
            <h4>Pooja Verma</h4>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever.
            </p>
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="img_box">
            <div className="uimg_box">
              <img src="img/Alex-Tsepaev.png" alt="img" className="user_img" />
            </div>
            <h4>Alex Tsepaev</h4>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever.
            </p>
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="img_box">
            <div className="uimg_box">
              <img src="img/t1.png" alt="img" className="user_img" />
            </div>
            <h4>Pooja Verma</h4>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever.
            </p>
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="img_box">
            <div className="uimg_box">
              <img src="img/Alex-Tsepaev.png" alt="img" className="user_img" />
            </div>
            <h4>Alex Tsepaev</h4>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
<Partners/>
  <section className="position-relative p70 ">
    <div className="container position-relative zindex">
      <h2 className="hadding ttu text-center mb-4 mb-md-5">
        {" "}
        Interactive <span className="color1"> Map</span>
      </h2>
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <img src="img/map1.jpg" alt="Logo" className="img-fluid" />
        </div>
        <div className="col-lg-6">
          <img src="img/map2.jpg" alt="Logo" className="img-fluid" />
        </div>
      </div>
    </div>
  </section>
   <Flags/>

     
<Accommodation/>
  <section className="">
    <div className="container">
      <div className="man_right">
        <div className="row m-0">
          <div className="col-md-5   bg_lrft text-center">
            <div className="f_contat_boc">
              <i className="ii bi bi-geo-alt" />
              <h5>ADDRESS</h5>
              <p>
                South Korea, an East Asian nation on the southern half of the
                Korean Peninsula
              </p>
            </div>
            <div className="f_contat_boc mt-4">
              <i className="ii bi bi-headset" />
              <h5>CONTACT</h5>
              <a className="me-3" href="tel:+919876543210">
                <span>
                  <i className="bi bi-whatsapp" /> +91 9876543210
                </span>
              </a>
              <a href="mailto:info@korea.com">
                <span>
                  <i className="bi bi-envelope" /> info@korea.com
                </span>
              </a>
            </div>
          </div>
          <div className="col-md-7 p-0">
            <iframe
              className="googlemap"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1393252.7503539645!2d126.48437860513499!3d35.79830230636209!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x356455ebcb11ba9b%3A0x91249b00ba88db4b!2sSouth%20Korea!5e0!3m2!1sen!2sin!4v1731055189432!5m2!1sen!2sin"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
  <Footer/>
</> 
  )
}
